import { type FunctionalComponent, h } from '@stencil/core';
import {
  ChatIcons,
  ChatIconsColors,
} from '../../../conversational-search-types/conversational-search-types.type';
import { medaliaGenAiConfigurationObject } from '../../../../../../utils/medalia-integration/medalia-configurations';
import { showMedaliaComponent } from '../../../../../../utils/medalia-integration/medalia-integration';
import { ctaEventDispatcher, eventDispatcherForFunctionalComponents } from '../../../conversational-search-logic/utils/utils';

export const ConversationalSearchActionMessagesBody: FunctionalComponent<{
  color: ChatIconsColors;
  iconName: ChatIcons;
  text: string;
  ctaText?: string;
  conversationalSearchMedaliaFormId?: string;
  userQuery?: string;
  outroText?: string;
  language?: string;
  country?: string;
  isNewConversation?: boolean;
  newConversationCta?: string;
}> = (props) => {
    const {
      color,
      iconName,
      text,
      ctaText,
      conversationalSearchMedaliaFormId,
      isNewConversation,
      newConversationCta,
      userQuery,
      outroText,
      language,
      country,
    } = props;

    const medaliaEvents = () => {
        const medaliafallback = () =>
          eventDispatcherForFunctionalComponents(
            'conversational-search:medalia-fallback',
          );

        showMedaliaComponent(
          conversationalSearchMedaliaFormId,
          medaliaGenAiConfigurationObject(country, language),
          medaliafallback,
        );

        ctaEventDispatcher('Give us your feedback', userQuery);
    };

    const newConversationEvents = (item: string) => {
        eventDispatcherForFunctionalComponents(
          'conversational-search:ga-new-conversation', {
            keyword: userQuery,
            item
          }
        );

        eventDispatcherForFunctionalComponents('conversational-search:user-new-conversation');
    };

    const onClickAction = (item: string) => {
        if (conversationalSearchMedaliaFormId) medaliaEvents();
        if (isNewConversation) newConversationEvents(item);
    };

    return (
      <div
        class={{
          'conversational-search-action-messages-body': true,
          'conversational-search-action-messages-body--success': color === ChatIconsColors.SUCCESS_ICON_COLOR,
          'conversational-search-action-messages-body--with-outro': Boolean(outroText)
        }}
      >
        <se-icon color={color}>{iconName}</se-icon>
        <section>
          <span>{text}</span>
          {outroText ? (
            <span class="conversational-search-action-messages-body__outro">
              {outroText}
            </span>
          ) : (
            ''
          )}
          {ctaText ? (
            <qds-button
              onClick={() => onClickAction(newConversationCta)}
              text={ctaText}
              importance="subdued"
              icon-name={!isNewConversation ? 'chat-bubble-square-lines' : void 0}
              icon-library={!isNewConversation ? 'default' : void 0}
            />
          ) : (
            ''
          )}
        </section>
      </div>
    );
};
